import env from '../config/env';

/**
 * Get full image URL from backend filename
 * @param image - Image filename or full URL
 * @returns Full URL to the image
 */
export const getImageUrl = (image: string | null | undefined): string => {
  if (!image) {
    return '/media/blank.png';
  }

  // If it's already a full URL, return as is
  if (image.startsWith('http://') || image.startsWith('https://')) {
    return image;
  }

  // Otherwise, append base URL
  const baseUrl = env.apiUrl.replace('/api', '');
  return `${baseUrl}/uploads/${image}`;
};

/**
 * Get multiple image URLs from backend filenames
 * @param images - Array of image filenames or full URLs
 * @returns Array of full URLs
 */
export const getImageUrls = (images: (string | null | undefined)[]): string[] => {
  return images.map(img => getImageUrl(img)).filter(Boolean) as string[];
};

